import React from "react";
import LogoLockup from "@/components/LogoLockup";

/**
 * BrandLockup — official VdV brand block.
 *
 * Uses the page-4 lockup from the Manual de Marca (Junio 2023) which
 * already contains both the "VIAJA DE VERDAD." wordmark and the
 * "Focused on you." script tagline. The brass hairline and the
 * standalone FocusedTagline used by previous logo iterations are gone:
 * the lockup is a single official asset, period.
 *
 * size:
 *   - "intro"  → big hero / login centerpiece (200px)
 *   - "footer" → default 160px
 *
 * tone forwards to LogoLockup so the asset switches between the
 * navy-on-cream original (light tone) and the cream-on-transparent
 * inverse (dark tone).
 */
export default function BrandLockup({ size = "footer", tone = "dark", className = "" }) {
  const lockupSize = size === "intro" ? "xl" : "lg";
  const endorseFontSize = size === "intro" ? 12 : 11;
  const textTone = tone === "dark" ? "text-ivory" : "text-charcoal";

  return (
    <div
      className={`inline-flex flex-col items-center text-center ${className}`}
      data-testid={`brand-lockup-${size}`}
    >
      <LogoLockup variant="full" size={lockupSize} tone={tone} />

      <p
        className={`eyebrow ${textTone} mt-7 opacity-70`}
        style={{ letterSpacing: "0.32em", fontSize: endorseFontSize }}
        data-testid="brand-endorsement"
      >
        Singular Experiences&nbsp;·&nbsp;Est. 2016
      </p>
    </div>
  );
}
